module.exports = __webpack_public_path__ + "assets/sprites_emoji_16-05bf0a7d0343187a3a5cd180.png";